import React, { FC } from 'react';
import {
  Alert,
  Button,
  Card,
  CardBody,
  CardTitle,
  Col,
  FormGroup,
  Input,
  Label,
  Row,
} from 'reactstrap';
import { useTranslation } from '../translations';
import { useCheckboxState } from '../utils';
import { TermsLoader } from '.';

interface PolicyComponentProps {
  readonly isChild?: boolean;
  readonly onAccept: () => void;
}

export const PolicyComponent: FC<PolicyComponentProps> = ({ isChild, onAccept }) => {
  const { ts } = useTranslation();
  const [agreePrivacyTerms, setAgreePrivacyTerms] = useCheckboxState(false);
  const [agreeConTerms, setAgreeConTerms] = useCheckboxState(false);

  const continueDisabled = !agreePrivacyTerms || !agreeConTerms;
  return (
    <>
      <CardTitle>{ts('convention_policies')}</CardTitle>
      <hr />
      <Card className="card-terms" color="secondary" outline>
        <CardBody>
          <TermsLoader name="terms" />
        </CardBody>
      </Card>
      <hr />
      {isChild && (
        <>
          <Alert color="primary">
            <TermsLoader name="underageWarning" />
          </Alert>
          <hr />
        </>
      )}

      <Row className="justify-content-center">
        <Col className="mt-10" lg={8} xs={12}>
          <FormGroup check className="mt-10 text-start">
            <Input
              id="agreeConTerms"
              name="agreeConTerms"
              onChange={setAgreeConTerms}
              type="checkbox"
            />
            <Label check for="agreeConTerms">
              {ts('i_have_read_and_agree')}
            </Label>
          </FormGroup>
          <FormGroup check className="mt-10 text-start">
            <Input
              id="agreePrivacyTerms"
              name="agreePrivacyTerms"
              onChange={setAgreePrivacyTerms}
              type="checkbox"
            />
            <Label check for="agreePrivacyTerms">
              {ts('i_have_read_and_agree_to_the')}&nbsp;
              <a href="/policy/privacy" target="_blank">
                {ts('privacy_policy')}
              </a>
              .
            </Label>
          </FormGroup>
          <Button
            block
            className="my-2"
            color="primary"
            disabled={continueDisabled}
            id="step2Continue"
            onClick={onAccept}
          >
            {ts('common.continue')}
          </Button>
        </Col>
      </Row>
    </>
  );
};
